module.exports = __webpack_public_path__ + "img/fit20.305ae747.png";